<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <div class="error-template">
          <div id="sign-wrapper">
            <div id="hole1" class="hole"></div>
            <div id="hole2" class="hole"></div>
            <div id="hole3" class="hole"></div>
            <div id="hole4" class="hole"></div>
            <header id="header">          
              <h1>Session Expired!!</h1>
            </header>
            <section id="sign-body">
              <div id="copy-container">
                <h2 style="line-height: 1.5em;"> Your session has been expired due to inactivity.</h2>
                <p>
                  You need to Login again.
                </p>
              
                 
              </div>
              
              <div id="circle-container">
                <svg
                  version="1.1"
                  viewBox="0 0 500 500"
                  preserveAspectRatio="xMinYMin meet"
                >
                  <defs>
                    <pattern
                      id="image"
                      patternUnits="userSpaceOnUse"
                      height="500"
                      width="500"
                    >
                      <image
                        x="45"
                        y="50"
                        height="400"
                        width="250"
                        xlink:href="../assets/images/clock.png"
                      ></image>
                    </pattern>
                  </defs>
                  <circle
                    cx="250"
                    cy="250"
                    r="200"               
                    fill="url(#image)"
                  />
                
                </svg>
             
              </div>
             
            </section>
               <div class="justify-center" style="display:flex;">
                <a-btn
                  color="primary"
                  @click="loginWithAuth0()"
                >Login</a-btn>
               
                </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LandingView from "../components/LandingView.vue";
import userAuthService from "../api/userAuthorizationService";

export default {
  components: { LandingView },
  name: "SessionExpired",
  methods:{
     loginWithAuth0() {
      this.$auth.getTokenWithPopup().then(async (response) => {
        await userAuthService.setActivityLog("login")
        this.$router.go(-1);
      });
    },
  }
};
</script>
<style >
:root {
  --hole-distance: 25px;
}
</style>
<style scoped>
#hole1 {
  top: var(--hole-distance);
  left: var(--hole-distance);
}
#hole2 {
  top: var(--hole-distance);
  right: var(--hole-distance);
}
#hole3 {
  bottom: var(--hole-distance);
  left: var(--hole-distance);
}
#hole4 {
  bottom: var(--hole-distance);
  right: var(--hole-distance);
}

.hole {
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  background-image: radial-gradient(circle at 99%, var(--v-Neutral-base) 10%, grey 70%);
  transform: rotate(45deg);
}

#sign-wrapper {
  background-color: var(--v-appBar-base);
  position: relative;
  width: 55%;
  min-width: 340px;
  max-width: 800px;
  height: 60%;
  margin: 1% auto;
  padding: 50px;
  border: 1px solid #e9ecf0;
  border-radius: 45px;
  box-shadow: 5px 5px 10px #000;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
}

#header {
  background-color: #ef5350;
  padding: 20px;
  border-radius: 30px 30px 0 0;
  text-align: center;
}

h1 {
  text-transform: uppercase;
  color: var(--v-Neutral-base);
  font-size: 3em;
  line-height: 0.9em;
  letter-spacing: 3px;
  margin: 0;
  font-weight: 900;
}

.strike {
  text-decoration: line-through;
}
#strike1 {
  text-decoration: line-through;
}
#strike2 {
  top: 6.5em;
  right: 5em;
}

#sign-body {
  display: flex;
  flex-wrap: nowrap;
}
#copy-container {
  flex-basis: 70%;
}
#circle-container {
  flex-basis: 30%;
}

h2,
p {
  text-align: center;
  color: #1d1e22;
}

h2 {
  font-size: 2em;
  text-transform: uppercase;
  margin: 20px 0;
  line-height: 0.9em;
}
p {
  font-size: 1.5em;
}

@media screen and (max-width: 930px) {
  #sign-wrapper {
    font-size: 0.75rem;
  }
}
@media screen and (max-width: 750px) {
  #sign-wrapper {
    font-size: 0.6rem;
  }
  h2 {
    margin: 25px 0;
  }
}
@media screen and (max-width: 600px) {
  #sign-wrapper {
    font-size: 0.4rem;
    padding: 15px;
    border-radius: 25px;
  }
  #header {
    border-radius: 20px 20px 0 0;
  }
  #circle-container {
    width: 50%;
  }
  .hole {
    width: 10px;
    height: 10px;
  }
  :root {
    --hole-distance: 8px;
  }
}
@media screen and (max-width: 450px) {
  #sign-wrapper {
    font-size: 0.34rem;
  }
  h2 {
    margin: 10px;
  }
  p {
    font-size: 14px;
  }
}
</style>